import { Component, Injector } from '@angular/core';
import { NgControl } from '@angular/forms';
import { RegionDropdownComponentConfigurator } from './region-dropdown-component.configurator';
import { BaseComboboxDropdownComponent } from '@pl/pl-lib/forms';
import { Region } from 'src/app/core/models/region';

@Component({
  selector: 'app-region-searchable-dropdown',
  templateUrl:
    '../../../../../../node_modules/@pl/pl-lib/assets/templates/searchable-dropdown/combobox-dropdown.component.html',
  styleUrls: [
    '../../../../plLibSetup/components/searchable-dropdown/combobox-dropdown.component.scss'
  ]
})
export class RegionSearchableDropdownComponent extends BaseComboboxDropdownComponent<Region> {
  constructor(ngControl: NgControl, injector: Injector) {
    super(ngControl, injector);
    this.configurator = new RegionDropdownComponentConfigurator();
  }
}
